import details from '../../../data/details.json';

import { Box, Typography } from "@mui/material";

export default function Header(){
    return(
        <Box
            sx={{
                backgroundColor:'primary.main',
                color:'primary.contrastText',
                height:"150px"
            }}
        >
            <Typography variant='h4' color='secondary'  sx={{ fontFamily: '"Theano Didot", serif', fontWeight: 500 }}>
                ΨΗΤΟΠΩΛΕΙΟ ΣΟΥΒΛΑΚΙ
            </Typography>
            <Typography variant="h2" color='secondary' sx={{ fontFamily: '"Theano Didot", serif', fontWeight: 500,   fontStyle: 'italic'}}>
                {details.title}
            </Typography>
            <Typography variant="subtitle1" sx={{p:1}}>
                {details.subtitle}
            </Typography>
        </Box>);
}